import React, { useState } from 'react';
import BrandfetchDisplay from './BrandfetchDisplay';
import BrandfetchSinglePageDisplay from './BrandfetchSinglePageDisplay';

/**
 * BrandfetchSelector Component
 * Allows users to choose between different Brandfetch display layouts
 * 
 * @param {Object} props - Component props
 * @param {string} props.domain - The domain to fetch data for
 * @param {Function} props.onClose - Function to call when closing the display
 */
const BrandfetchSelector = ({ domain, onClose }) => {
    const [displayMode, setDisplayMode] = useState('single-page'); // 'tabbed' or 'single-page'
    
    const handleModeChange = (mode) => {
        setDisplayMode(mode);
    };
    
    return (
        <>
            {displayMode === 'tabbed' ? (
                <BrandfetchDisplay 
                    domain={domain} 
                    onClose={onClose} 
                    onSwitchView={() => handleModeChange('single-page')}
                />
            ) : (
                <BrandfetchSinglePageDisplay 
                    domain={domain} 
                    onClose={onClose} 
                    onSwitchView={() => handleModeChange('tabbed')}
                />
            )}
        </>
    );
};

export default BrandfetchSelector; 